import React from "react";
import { useI18n } from "../i18n";

// Inline SVG flags — reliable across Windows/Linux Chrome where flag emojis
// otherwise fall back to country-code text (e.g. "TR", "GB").
const TrFlag = (props) => (
  <svg viewBox="0 0 60 40" width="18" height="12" aria-hidden="true" {...props}>
    <rect width="60" height="40" fill="#E30A17" />
    <circle cx="22" cy="20" r="9" fill="#fff" />
    <circle cx="25" cy="20" r="7.2" fill="#E30A17" />
    <polygon
      points="35,20 30.5,21.5 33.3,17.7 33.3,22.3 30.5,18.5"
      fill="#fff"
    />
  </svg>
);

const GbFlag = (props) => (
  <svg viewBox="0 0 60 30" width="18" height="12" aria-hidden="true" {...props}>
    <clipPath id="ukc">
      <rect width="60" height="30" />
    </clipPath>
    <g clipPath="url(#ukc)">
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path
        d="M0,0 L60,30 M60,0 L0,30"
        stroke="#C8102E"
        strokeWidth="2.5"
        clipPath="polygon(0 0,50% 50%,100% 0,100% 0,50% 50%,100% 100%,100% 100%,50% 50%,0 100%,0 100%,50% 50%,0 0)"
      />
      <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
    </g>
  </svg>
);

export default function LangToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  const btn = (code, Flag, label) => (
    <button
      key={code}
      type="button"
      onClick={() => setLang(code)}
      data-testid={`lang-${code}`}
      aria-pressed={lang === code}
      className={`flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium transition-colors ${
        lang === code
          ? "bg-[#14512f] text-white"
          : "text-[#4b544c] hover:bg-[#eef1e9]"
      }`}
    >
      <Flag className="rounded-[2px]" />
      <span className="tracking-wide">{label}</span>
    </button>
  );
  return (
    <div
      className={`inline-flex items-center gap-1 rounded-lg border border-[#e4e6dd] bg-white p-1 ${className}`}
      data-testid="lang-toggle"
    >
      {btn("tr", TrFlag, "TR")}
      {btn("en", GbFlag, "EN")}
    </div>
  );
}
